import {createSlice, PayloadAction} from "@reduxjs/toolkit";
import {loadClubs} from "./asyncActions";
import {Club} from "../../../api/ClubService";

interface State {
    allClubs: Club[]
    clubIdFromUrl?: string
    selectedClub?: Club
}

const initialState: State = {
    allClubs: [],
    clubIdFromUrl: undefined,
};

export interface LoadClubsActionPayload {
    clubs?: Club[]
}

let clubSelectionSlice = createSlice(
    {
        name: "Clubs",
        initialState: initialState,
        reducers: {
            handleClubIdFromUrl: (state, action: PayloadAction<string | undefined>) => {
                state.clubIdFromUrl = action.payload
                console.log('club id from url set')
            },
            findSelectedClub: (state) => {
                const selectedClub = state.allClubs
                    .find((item) => item.id === state.clubIdFromUrl);
                if (!selectedClub) {
                    return;
                }

                state.selectedClub = selectedClub
            }
        },
        extraReducers: (builder) => {
            builder.addCase(
                loadClubs.fulfilled,
                (state, action: PayloadAction<LoadClubsActionPayload>) => {
                    if (action.payload.clubs) {
                        state.allClubs = action.payload.clubs
                    }
                }
            )
        }
    }
);

export const {
    handleClubIdFromUrl,
    findSelectedClub,
} = clubSelectionSlice.actions;

export default clubSelectionSlice.reducer;